import { Suggestion } from '@models/Suggestion/Suggestion.interface';
import {
  SET_COUNT,
  SET_SUGGESTIONS,
  CLEAR_COUNT,
  CLEAR_SUGGESTIONS,
  START_SEARCH_LOADING,
  FINISH_SEARCH_LOADING,
  SET_BLOCKED,
  SET_SEARCH_VALUE,
} from './types';

export function clearCount() {
  return {
    type: CLEAR_COUNT,
  };
}

export function clearSuggestions() {
  return {
    type: CLEAR_SUGGESTIONS,
  };
}

export function setCount(count: number) {
  return {
    type: SET_COUNT,
    payload: count,
  };
}

export function setSearchValue(value: string) {
  return {
    type: SET_SEARCH_VALUE,
    value,
  };
}

export function setSuggestions(suggestions: Suggestion[]) {
  return {
    type: SET_SUGGESTIONS,
    suggestions: suggestions,
  };
}

export function startLoading() {
  return {
    type: START_SEARCH_LOADING,
  };
}

export function finishLoading() {
  return {
    type: FINISH_SEARCH_LOADING,
  };
}

export function setBlocked(isBlocked: boolean) {
  return {
    type: SET_BLOCKED,
    isBlocked,
  };
}
